/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowstylegrafik3Inputs */

const en_aiflowstylegrafik3 = /** @type {(inputs: Aiflowstylegrafik3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graphic`)
};

const de_aiflowstylegrafik3 = /** @type {(inputs: Aiflowstylegrafik3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grafik`)
};

/**
* | output |
* | --- |
* | "Graphic" |
*
* @param {Aiflowstylegrafik3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowstylegrafik3 = /** @type {((inputs?: Aiflowstylegrafik3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowstylegrafik3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowstylegrafik3(inputs)
	return de_aiflowstylegrafik3(inputs)
});
export { aiflowstylegrafik3 as "aiFlowStyleGrafik" }